const labels = [
  { hash: "#/submitdatasets", label: "Submit Dataset" },
  { hash: "#/submitfiles", label: "Submit Files" },
  { hash: "#/datasetsubmitted", label: "Submitted Datasets - Summary" },
  { hash: "#/filesubmitted", label: "Submitted Files - Summary" },
  { hash: "#/datasets", label: "Datasets View" },
  { hash: "#/files", label: "Files View" },
];

function getPath(hash) {
  let found = labels.find((x) => x.hash === hash);
  if (found) {
    return found.label;
  }
  let search = labels.find((x) => hash.includes(x.hash));
  if (search !== undefined) {
    return search.label;
  }
  return null;
}

export default getPath;
